<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="PayoutRequest" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { PayoutRequestProps } from './PayoutRequest.ts';
import PayoutRequest from './PayoutRequest.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-payout-request';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<PayoutRequestProps>();
const changableProps = useChangableProps(componentName, props);

</script>
